import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { sevenIslands, sevenIslandsPhotos } from '../data/sevenIslands';
const ease = [0.23, 1, 0.32, 1] as const;

// Home teaser: three renderings not used in the hero slideshow.
const teaserTitles = ['Resort lagoon', 'The Resort at Cape Coral', 'Waterfront dining'];
const teaser = teaserTitles.map(t => sevenIslandsPhotos.find(p => p.title === t)).filter((p): p is (typeof sevenIslandsPhotos)[number] => Boolean(p));
export function SevenIslands() {
  const [lead, ...rest] = teaser;
  return <section id="seven-islands" className="bg-[#0A0A0A] text-white py-24 px-6 md:px-10 scroll-mt-24" data-id="element-227" data-mp="ukej7lncv1te">
      <div className="max-w-7xl mx-auto" data-id="element-228" data-mp="zizinius9hgs">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14 items-end" data-id="element-229" data-mp="261xqbp423ox8">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          ease
        }} className="lg:col-span-7" data-id="element-230" data-mp="2azprzaui6pem">
            <p className="text-[#C5A55A] text-xs tracking-[0.3em] uppercase mb-5" data-id="element-231" data-mp="17z1gta0qtih3">
              Upcoming development · Coming {sevenIslands.opening}
            </p>
            <h2 className="font-serif font-bold leading-tight" data-id="element-232" data-mp="y26iar4gzi2t">
              <span className="block text-4xl md:text-6xl" data-id="element-233" data-mp="t451kcuinuui">{sevenIslands.name}</span>
              <span className="block text-2xl md:text-3xl text-[#C5A55A] italic font-normal mt-2" data-id="element-234" data-mp="od53v5dkp8qy">
                {sevenIslands.subtitle}
              </span>
            </h2>
            <p className="flex items-center gap-2 text-gray-400 mt-6" data-id="element-235" data-mp="k8xc0zbtjcoi">
              <MapPin className="w-4 h-4 text-[#C5A55A] shrink-0" aria-hidden="true" data-id="element-236" data-mp="fdrro4y2e62j" />
              {sevenIslands.location}
            </p>
          </motion.div>

          <div className="lg:col-span-5" data-id="element-237" data-mp="5ditwmofccl1">
            <p className="text-xl text-gray-100 font-light leading-relaxed mb-8" data-id="element-238" data-mp="5essre33posq">
              {sevenIslands.tagline}
            </p>
            <Link to={sevenIslands.slug} className="group inline-flex items-center gap-2 bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-8 py-4 font-medium rounded-sm transition-colors duration-200" data-id="element-239" data-mp="phzyk4z0m1g">
              Explore 7 Islands
              <ArrowRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-240" data-mp="3mysnjkasxhrn" />
            </Link>
          </div>
        </div>

        <Link to={sevenIslands.slug} className="grid grid-cols-1 md:grid-cols-3 gap-4" aria-label="See all 7 Islands renderings" data-id="element-241" data-mp="5oku39jex7un">
          {lead && <div className="group relative md:col-span-2 md:row-span-2 overflow-hidden" data-id="element-242" data-mp="9ntomgma19r9">
              <img src={lead.src} alt={lead.title} className="w-full h-72 md:h-[520px] object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-243" data-mp="xdnz4rj4im8c" />
              <span className="absolute inset-x-0 bottom-0 px-5 py-4 bg-black/60 font-serif text-lg" data-id="element-244" data-mp="2hycmbiha0ytq">
                {lead.title}
              </span>
            </div>}
          {rest.map(photo => <div key={photo.src} className="group relative overflow-hidden" data-id="element-245" data-mp="2rncnn8j946b3">
              <img src={photo.src} alt={photo.title} className="w-full h-56 md:h-[252px] object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-246" data-mp="23xs1kgrswsxl" />
              <span className="absolute inset-x-0 bottom-0 px-5 py-4 bg-black/60 font-serif text-base" data-id="element-247" data-mp="2dwzfp66d0rlr">
                {photo.title}
              </span>
            </div>)}
        </Link>

        <div className="mt-8 flex justify-end" data-id="element-248" data-mp="3pa1wa18glh5x">
          <Link to={sevenIslands.slug} className="text-white hover:text-[#C5A55A] font-medium border-b-2 border-[#C5A55A] pb-1 transition-colors duration-200" data-id="element-249" data-mp="3kca5jajjw13b">
            See all renderings and the master plan
          </Link>
        </div>
      </div>
    </section>;
}